import InvestorSummaryForm from './InvestorSummaryForm'

export default InvestorSummaryForm
